import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class ResetPasswordRequest {
  @jsonMember readonly password!: string;

  constructor(password: string) {
    this.password = password;
  }
}
